<template>
  <main class="premium-page">
    <section class="premium-hero" v-reveal>
      <div class="premium-hero__content">
        <p class="section-kicker">{{ premium.kicker }}</p>
        <h1>{{ premium.title }}</h1>
        <p>{{ premium.copy }}</p>
        <div class="premium-hero__actions">
          <a class="action-button action-button--premium action-button--large" :href="premium.primaryAction.href">
            <AppIcon :name="premium.primaryAction.icon" />
            <span>{{ premium.primaryAction.label }}</span>
          </a>
          <a class="action-button action-button--muted action-button--large" :href="premium.secondaryAction.href">
            <AppIcon :name="premium.secondaryAction.icon" />
            <span>{{ premium.secondaryAction.label }}</span>
          </a>
        </div>
      </div>

    </section>

    <section id="premium-plans" class="premium-plans" aria-label="Premium Pläne">
      <article
        v-for="plan in premium.plans"
        :key="plan.name"
        class="premium-plan"
        :class="{ 'premium-plan--featured': plan.featured }"
        v-reveal
      >
        <div class="premium-plan__top">
          <span class="premium-plan__icon">
            <AppIcon :name="plan.icon" />
          </span>
          <div class="premium-plan__chips">
            <span v-if="plan.badge" class="premium-plan__badge">{{ plan.badge }}</span>
            <span v-if="plan.notice" class="premium-plan__notice">
              <AppIcon name="megaphone" />
              {{ plan.notice }}
            </span>
          </div>
        </div>
        <h2>{{ plan.name }}</h2>
        <p>{{ plan.description }}</p>
        <div class="premium-plan__price">
          <strong>{{ plan.price }}</strong>
          <span>{{ plan.period }}</span>
        </div>
        <ul>
          <li v-for="highlight in plan.highlights" :key="highlight">
            <AppIcon name="shield" />
            <span>{{ highlight }}</span>
          </li>
        </ul>
        <a class="premium-plan__action" :href="plan.href">{{ plan.action }}</a>
      </article>
    </section>

    <section class="premium-comparison" v-reveal>
      <div class="premium-comparison__header">
        <div>
          <p class="section-kicker">{{ premium.kicker }}</p>
          <h2>{{ premium.tableTitle }}</h2>
        </div>
        <p>{{ premium.tableCopy }}</p>
      </div>

      <div class="premium-table" role="table" aria-label="Premium Vergleich">
        <div class="premium-table__row premium-table__row--head" role="row">
          <span role="columnheader"></span>
          <strong v-for="column in premium.comparisonColumns" :key="column" role="columnheader">{{ column }}</strong>
        </div>

        <template v-for="group in premium.comparisonGroups" :key="group.title">
          <div class="premium-table__group" role="row">
            <strong>{{ group.title }}</strong>
          </div>
          <div v-for="row in group.rows" :key="`${group.title}-${row.label}`" class="premium-table__row" role="row">
            <span role="cell">{{ row.label }}</span>
            <span v-for="(value, index) in row.values" :key="`${row.label}-${index}`" role="cell">
              <span v-if="value === true" class="premium-table__check" :aria-label="premium.includedLabel">
                <AppIcon name="shield" />
              </span>
              <span v-else-if="value === false" class="premium-table__x" :aria-label="premium.notIncludedLabel">×</span>
              <strong v-else>{{ value }}</strong>
            </span>
          </div>
        </template>
      </div>

      <p class="premium-comparison__note">{{ premium.note }}</p>
    </section>
  </main>
</template>

<script>
import AppIcon from './AppIcon.vue'

export default {
  name: 'PremiumPage',
  components: {
    AppIcon
  },
  props: {
    premium: {
      type: Object,
      required: true
    }
  }
}
</script>
